// extracted by mini-css-extract-plugin
export default {"body":"UploadTab_body__aFA5r","link":"UploadTab_link__jEGrB","error":"UploadTab_error__mZRSQ","hint":"UploadTab_hint__mE6Vv"};